// Storefront utilities (inlined since this is not a module)
const queryVariantsById = (ids) => {
  const graphQlVariables = {
    ids: Array.isArray(ids)
      ? ids.map(id => `gid://shopify/ProductVariant/${id}`)
      : [`gid://shopify/ProductVariant/${ids}`]
  };

  const graphQlQuery = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          title
          product {
            title
            availableForSale
          }
          storeAvailability(first: 250) {
            nodes {
              available
              quantityAvailable
              location {
                name
                id
              }
            }
          }
        }
      }
    }
  `;

  return JSON.stringify({
    query: graphQlQuery,
    variables: graphQlVariables
  });
};

const storefrontFetch = async (graphqlData) => {
  const storefrontConfig = window.storefront;
  if (!storefrontConfig?.apiToken || !storefrontConfig?.apiVersion || !storefrontConfig?.store) {
    console.warn('STOREFRONT_API_TOKEN, STOREFRONT_API_VERSION, or STORE is not set.');
    return null;
  }

  const fetchHeaders = new Headers();
  fetchHeaders.append('x-shopify-storefront-access-token', storefrontConfig.apiToken);
  fetchHeaders.append('Content-Type', 'application/json');

  const requestOptions = {
    method: 'POST',
    headers: fetchHeaders,
    body: graphqlData
  };

  const response = await fetch(`https://${storefrontConfig.store}/api/${storefrontConfig.apiVersion}/graphql.json`, requestOptions)
    .then(response => response.json());

  if (response.errors) {
    console.error(response.errors);
    return null;
  }

  return response.data;
};

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.productShippingDetails = this.closest('.product')?.querySelector('product-shipping-details') || this.closest('.plp-quick-add')?.querySelector('product-shipping-details');
      const firstInput = this.querySelector('input[type="radio"]:checked') || this.querySelector('input[type="radio"]');
      if (firstInput) {
        const event = new Event('change', { bubbles: true });
        firstInput.dispatchEvent(event);
      }
    }

    onVariantChange(event) {
      this.updateOptions();
      this.updateOptionValueText(event.target);
      this.updateVariantId();
      this.updateOptionDisabled(event.target);
      this.toggleAddButton(true);
      this.toggleQtySelector(true);
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.toggleAddButton(true);
        this.toggleQtySelector(true);
        this.setUnavailable();
        this.toggleBopis(true);
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();

        if (this.productShippingDetails) {
          this.productShippingDetails.reload(this.currentVariant);
        }
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (radio) => radio.value);
    }

    updateOptionValueText(target) {
      let optionValueTextElement = target.closest(".product-option-container").querySelector('[data-option-selected]');
      if (!optionValueTextElement) return;
      let newValue = target.dataset.optionText || target.value;
      optionValueTextElement.innerHTML = newValue;
    }

    updateVariantId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOptionDisabled(target) {
      this.variantData.forEach((variant) => {
        if (variant.option1 === target.value) {
          if (!variant.available) {
            variant.options.forEach((option, index) => {
              console.log("option not available", option);
              const inputElement = this.querySelector(`input[value="${option}"]`);
              if (inputElement && index > 0) {
                inputElement.classList.add("disabled");
              }
            });
          } else {
            variant.options.forEach((option, index) => {
              const inputElement = this.querySelector(`input[value="${option}"]`);
              if (inputElement && index > 0) {
                inputElement.classList.remove("disabled");
              }
            });
          }
      } else if (variant.option2 === target.value) {
        if (!variant.available) {
          variant.options.forEach((option, index) => {
            console.log("option not available", option);
            const inputElement = this.querySelector(`input[value="${option}"]`);
            if (inputElement && (index < 1 || index > 1)) {
              inputElement.classList.add("disabled");
            }
          });
        } else {
          variant.options.forEach((option, index) => {
            const inputElement = this.querySelector(`input[value="${option}"]`);
            if (inputElement && (index < 1 || index > 1)) {
              inputElement.classList.remove("disabled");
            }
          });
        }
      } else if (variant.option3 === target.value) {
        if (!variant.available) {
          variant.options.forEach((option, index) => {
            console.log("option not available", option);
            const inputElement = this.querySelector(`input[value="${option}"]`);
            if (inputElement && (index < 2)) {
              inputElement.classList.add("disabled");
            }
          });
        } else {
          variant.options.forEach((option, index) => {
            const inputElement = this.querySelector(`input[value="${option}"]`);
            if (inputElement && index < 2) {
              inputElement.classList.remove("disabled");
            }
          });
        }
      }
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      const mediaGallery = this.closest('.product')?.querySelector('media-gallery') || this.closest('.plp-quick-add')?.querySelector('media-gallery');
      if (!mediaGallery) { return; }
      mediaGallery.setActiveMedia(this.currentVariant);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms =
        document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Installment-${this.dataset.section}, #Product-Form-QuickView-${this.dataset.quickProductId}, #Gift-Form-${this.dataset.section}`);
        const productSku = document.querySelector('[data-pdp-sku]');

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');

        if (!input) {
          return;
        }
        
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('buildLocationsList'));
      });

      if (productSku) {
        productSku.innerText = this.currentVariant.sku;
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      //if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      if (this.dataset.isQuickview) {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
        .then((response) => response.text())
        .then(async (responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`Price-Quickview-${this.dataset.quickProductId}`);
          const source = html.querySelector('[data-pdp-price]');
          const inventoryLevels = await storefrontFetch(queryVariantsById(this.currentVariant.id));
          let stores = inventoryLevels?.nodes[0]?.storeAvailability?.nodes;
          if (!stores || !Array.isArray(stores)) {
            stores = [];
          }
          let warehouseHasInventory = false;
          stores.forEach((store) => {
            if (store.location.name.includes('Warehouse')) {
              warehouseHasInventory = store.available;
            }
          });
          let totalInventory = 0;
          stores.forEach((store) => {
            if (!store.location.name.includes('Warehouse')) {
              totalInventory += store.quantityAvailable;
            }
          });
          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(`Price-Quickview-${this.dataset.quickProductId}`);
          if (this.currentVariant.title.includes('Customize')) {
            this.toggleBopis(true);
          } else {
            this.toggleBopis(false);
          }

          let inventoryThreshold = window.inventoryThreshold;
          let variantThreshold = window.variant_thresholds[this.currentVariant.id];
          if (variantThreshold) {
            inventoryThreshold = variantThreshold;
          }

          if (price) price.classList.remove('invisible');
          let buttonAvailable = false;
          if (this.currentVariant.inventory_management === null) {
            buttonAvailable = this.currentVariant.available;
          } else if (warehouseHasInventory) {
            buttonAvailable = true;
          } else if (totalInventory > inventoryThreshold) {
            buttonAvailable = true;
          } else {
            buttonAvailable = false;
          }
          this.toggleAddButton(!buttonAvailable, window.variantStrings.soldOut);
          this.toggleQtySelector(!buttonAvailable);

        });
      } else {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then(async (responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`Price-${this.dataset.section}`);
          const source = html.getElementById(`Price-${this.dataset.section}`);
          const inventoryLevels = await storefrontFetch(queryVariantsById(this.currentVariant.id));
          let stores = inventoryLevels?.nodes[0]?.storeAvailability?.nodes;
          if (!stores || !Array.isArray(stores)) {
            stores = [];
          }
          let warehouseHasInventory = false;
          stores.forEach((store) => {
            if (store.location.name.includes('Warehouse')) {
              warehouseHasInventory = store.available;
            }
          });
          let totalInventory = 0;
          stores.forEach((store) => {
            if (!store.location.name.includes('Warehouse')) {
              totalInventory += store.quantityAvailable;
            }
          });
          if (source && destination) destination.innerHTML = source.innerHTML;

          let inventoryThreshold = window.inventoryThreshold;
          let variantThreshold = window.variant_thresholds[this.currentVariant.id];
          if (variantThreshold) {
            inventoryThreshold = variantThreshold;
          }

          const price = document.getElementById(`Price-${this.dataset.section}`);
          if (this.currentVariant.title.includes('Customize')) {
            this.toggleBopis(true);
          } else {
            this.toggleBopis(false);
          }

          if (price) price.classList.remove('invisible');
          let buttonAvailable = false;
          if (this.currentVariant.inventory_management === null) {
            buttonAvailable = this.currentVariant.available;
          } else if (warehouseHasInventory) {
            buttonAvailable = true;
          } else if (totalInventory > inventoryThreshold) {
            buttonAvailable = true;
          } else {
            buttonAvailable = false;
          }
          this.toggleAddButton(!buttonAvailable, window.variantStrings.soldOut);
          this.toggleQtySelector(!buttonAvailable);

        });
      }

    }

    toggleAddButton(disable = true, text) {
      let productForm;
      if (this.dataset.isQuickview) {
        productForm = document.getElementById(`Product-Form-QuickView-${this.dataset.quickProductId}`);
      } else {
        productForm = document.getElementById(`Product-Form-${this.dataset.section}`);
      }

      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    toggleQtySelector(disable = true) {
      const qtySelector = document.getElementById(`Quantity-Form-${this.dataset.section}`);
      if (!qtySelector) return;

      const qtyInput = qtySelector.querySelector('input');
      const qtyInputButtons = qtySelector.querySelectorAll('.quantity__button');
      if (!qtyInput) return;

      if (disable) {
        qtyInput.setAttribute('disabled', 'disabled');
        qtyInputButtons.forEach((button) => button.setAttribute('disabled', 'disabled'));
      } else {
        qtyInput.removeAttribute('disabled');
        qtyInputButtons.forEach((button) => button.removeAttribute('disabled'));
      }
    }

    toggleBopis(hide = true) {
      const bopis = document.querySelector('product-shipping-details');
      if (!bopis) return;
      if (hide) {
        bopis.classList.add('hidden');
      } else {
        bopis.classList.remove('hidden');
      }
    }

    setUnavailable() {
      let button;
      if (this.dataset.isQuickview) {
        button = document.getElementById(`Product-Form-QuickView-${this.dataset.quickProductId}`);
      } else {
        button = document.getElementById(`Product-Form-${this.dataset.section}`);
      }
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      let price;
      if (this.dataset.isQuickview) {
        price = document.getElementById(`Price-Quickview-${this.dataset.quickProductId}`)
      } else {
        price = document.getElementById(`Price-${this.dataset.section}`);
      }

      if (!addButton) return;

      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('invisible');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  });
}
